module.exports = __webpack_public_path__ + "static/media/ca_10.00a3ec9e.png";